// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3l8Jg","header":"ReportDetails_header__2FnGz","title":"ReportDetails_title__pT4Ac","left":"ReportDetails_left__2fI1o"};